// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'tiny... Remove this comment to see the full error message
import tinymce from 'tinymce';
import ReactDOM from 'react-dom';
import { userInfoSync } from 'hub-http/userInfo';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../d... Remove this comment to see the full error message
import { resetAutocompleteAtomState } from '../data/autocompleteAtoms';
import { appendDivToEditor } from '../utils';
import { getPickerComponent } from './settings';
import { getMceRootNode } from './namespace';
import { jsx as _jsx } from "react/jsx-runtime";
// DOM nodes created to serve as render targets for React
let fileManagerDomNode = null;
export function openFileManager(editor, type, onInsert, initialPanel) {
  if (!fileManagerDomNode) {
    const container = appendDivToEditor(editor, 'filemanager-modal-container');
    if (!container) {
      console.error('Could not append div to editor. Failed to open file manager.');
      return;
    }
    fileManagerDomNode = container;
  }
  const FilePicker = getPickerComponent(editor, 'FilePicker', '`FilePicker` picker component is required for file access');
  const unmountDrawer = () => {
    ReactDOM.unmountComponentAtNode(fileManagerDomNode);
    resetAutocompleteAtomState();
  };
  const handleCloseComplete = () => {
    tinymce.util.Delay.setEditorTimeout(editor, () => {
      editor.focus();
    });
  };
  const handleInsert = file => {
    // `file-manager-components` iframed picker returns files as plain objects, `FileManagerLib` picker returns immutable Maps
    file = file.toJS ? file.toJS() : file;
    onInsert(file);
    unmountDrawer();
  };
  ReactDOM.render( /*#__PURE__*/_jsx(FilePicker, {
    pickerType: "SIDE_MODAL",
    type: type,
    initialPanel: initialPanel,
    userInfo: userInfoSync(),
    onSelect: handleInsert,
    onClose: unmountDrawer,
    onCloseComplete: handleCloseComplete,
    rootNode: getMceRootNode(),
    className: "mce-file-picker",
    dropdownClassName: "mce-file-picker-uploader",
    renderContext: "tinymce-plugins"
  }), fileManagerDomNode);
}